<template>
    <LabelBox :id="id" :label-col="labelCol" :control-col="controlCol" :label="label">
        <template #default="slot">
            <input :id="slot.id" class="form-control" :type="type || 'text'" :name="name" v-bind="$attrs">
        </template>
    </LabelBox>
</template>

<script>
'use strict';

import LabelBox from './bootstrap-labelbox.vue';

export default {
    components: {
        LabelBox,
    },
    inheritAttrs: false,
    // eslint-disable-next-line vue/require-prop-types
    props: ['labelCol', 'controlCol', 'labelClass', 'label', 'name', 'id', 'type'],
};
</script>
